import Client from './Clients/AxiosClient';
const resource = '/api';

export default {
    patients() {
        return Client.get(`${resource}/Patient`,  {
            withCredentials: true, responseType: 'json'
          })
    },
    filterPatients(filter) {
        return Client.get(`${resource}/Patient/` + filter, {
            withCredentials: true, responseType: 'json'
          })
    },
    patientCredentials(credentials) {
        return Client.get(`${resource}/PatientCredentals/` + credentials, {
            withCredentials: true, responseType: 'json'
          })
    },
    updatePatientCredentials(credentials) {
        return Client.post(`${resource}/PatientCredentals/` + credentials, {
            withCredentials: true, responseType: 'json'
          })
    },
    emailPatient(credentials) {
        return Client.get(`${resource}/Email/` + credentials, {
            withCredentials: true, responseType: 'json'
          })
    },
};